import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { SearchInput } from '../../../../../LightweightFilterMenu/components/SearchInput';
import { ix } from '../../../../../../../../utils/ix';
import { useStyles } from './AddFilterMenuContent.styles';
export const AddFilterMenuContent = memo(({ id, isOpen, fieldNameOptions, onClick }) => {
    const [search, setSearch] = useState('');
    const classes = useStyles();
    useEffect(() => {
        if (!isOpen) {
            setSearch('');
        }
    }, [isOpen]);
    const filteredOptions = useMemo(() => {
        return fieldNameOptions.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
    }, [fieldNameOptions, search]);
    const handleOnSearchChange = useCallback((value) => {
        setSearch(value);
    }, []);
    return (React.createElement(Box, { id: id, className: classes.root },
        React.createElement(SearchInput, { id: ix(id, 'search'), placeholder: "Filters", value: search, onChange: handleOnSearchChange }),
        filteredOptions.length === 0 && (React.createElement("span", { id: ix(id, 'no-options'), className: classes.noOptions }, "No options")),
        filteredOptions.length > 0 && (React.createElement(Box, { id: ix(id, 'option-list'), className: classes.list }, filteredOptions.map((option) => (React.createElement("span", { id: ix(id, 'option', option.value), key: option.value, className: classes.listItem, onClick: () => onClick(option) }, option.label)))))));
});
//# sourceMappingURL=AddFilterMenuContent.js.map